import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { 
  DocumentTypeMaster, 
  DocumentType, 
  AddDocumentTypeRequest, 
  UpdateDocumentTypeRequest,
  DocumentTypeUsageResponse,
  ApiResponse 
} from '../models/document-management.models';

@Injectable({
  providedIn: 'root',
})
export class DocumentManagementService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

  private readonly ERROR_MISSING_PLANT_CODE = 'Plant code is required';

  constructor(private http: HttpClient) { }

  // sending request for getting document types

  getDocumentTypesMaster(plantCode: string): Observable<DocumentTypeMaster[]> {
    if (!plantCode) {
      return throwError(() => new Error(this.ERROR_MISSING_PLANT_CODE));
    }

    const params = new HttpParams().set('plantCode', plantCode);

    return this.http.get<DocumentTypeMaster[]>(
      this.baseUrl + 'documentManagement/getDocumentTypesMaster',
      { params }
    ).pipe(
      retry(2),
      catchError((error) => {
        console.error('Error fetching document types master:', error);
        return throwError(() => ({
          message: error.error?.message || 'Failed to fetch document types',
          status: error.status
        }));
      })
    );
  }

  getDocumentTypes(key: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/getDocumentsTypes',
      key
    );
  }
  SendChatMail(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/SendChatMail',
      data
    );
  }
  addDocumentType(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/addDocumentType',
      data
    );
  }
  editDocumentType(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/editDocumentType',
      data
    );
  }
  deleteDocumentType(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/deleteDocumentType',
      data
    );
  }

  // sending request for getting related process master

  getRelatedProcessMaster(key: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/getRelatedProcessMaster',
      key
    );
  }
  addRelatedProcessMaster(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/addRelatedProcessMaster',
      data
    );
  }
  editRelatedProcessMaster(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/editRelatedProcessMaster',
      data
    );
  }
  deleteRelatedProcessMaster(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/deleteRelatedProcessMaster',
      data
    );
  }

  // getting documents list
  getDocumentsByPlant(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/getDocumentsByPlant',
      data
    );
  }
  getDocumentListByPlant(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/getDocumentListByPlant',
      data
    );
  }

  // getting next document number
  getDocumentNumber(key: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/getDocumentNumber',
      key
    );
  }

  // getting document details
  getDocumentByKey(key: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/getDocumentByKey',
      key
    );
  }

  getempDataByUserId(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "DocumentManagement/GetEmpDataByUserId", data);
  }

  // saving new document
  saveNewDocument(data: any): Observable<any> {
    // const request = new HttpRequest('POST', this.baseUrl + 'documentManagement/saveDocument', data, {
    //   reportProgress: true
    // });
    // return this.http.request(request);
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/saveDocument',
      data
    );
  }

  editSavedDocument(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/EditSavedDocument',
      data
    );
  }

  // saving distribution
  addDistribution(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/addDistribution',
      data
    );
  }
  // getting distributions by revision id
  getDistributionByRevision(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/getDistributionsByRevision',
      data
    );
  }

  getAllDistribution(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/getAllDistribution',
      data
    );
  }

  // editing distribution
  editDistribution(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/editDistribution',
      data
    );
  }
  // delete distribution
  deleteDistribution(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/deleteDistribution',
      data
    );
  }
  // add acknowledged
  addAcknowledged(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/addAcknowledged',
      data
    );
  }

  // change request routes
  getChangeRequestStatuses(): Observable<any> {
    return this.http.get<any>(
      this.baseUrl + 'documentManagement/getChangeRequestStatuses'
    );
  }
  getChangeRequestSeverity(): Observable<any> {
    return this.http.get<any>(
      this.baseUrl + 'documentManagement/getChangeRequestSeverity'
    );
  }
  getChangeRequestNumber(): Observable<any> {
    return this.http.get<any>(
      this.baseUrl + 'documentManagement/getChangeRequestNumber'
    );
  }
  addChangeRequest(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/addChangeRequest',
      data
    );
  }
  getChangeRequestByDocument(key: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/getChangeRequestByDocument',
      key
    );
  }
  editChangeRequest(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/editChangeRequest',
      data
    );
  }
  deleteChangeRequest(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/deleteChangeRequest',
      data
    );
  }
  approveMultipleChangeRequest(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/approveMultipleChangeRequest',
      data
    );
  }

  // revision api routes
  addRevision(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/addRevision',
      data
    );
  }
  // review api routes
  addReview(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/addReview',
      data
    );
  }
  editReview(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/editReview',
      data
    );
  }
  deleteReview(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/deleteReview',
      data
    );
  }
  getReviewByDocument(key: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/getReviewsHistory',
      key
    );
  }

  // document properties routes
  addRelatedDocument(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/addRelatedDocument',
      data
    );
  }
  editRelatedDocument(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/editRelatedDocument',
      data
    );
  }
  deleteRelatedDocument(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/deleteRelatedDocument',
      data
    );
  }
  getRelatedDocuments(key: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/getRelatedDocuments',
      key
    );
  }
  addRelatedDepartment(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/addRelatedDepartment',
      data
    );
  }
  editRelatedDepartment(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/editRelatedDepartment',
      data
    );
  }
  deleteRelatedDepartment(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/deleteRelatedDepartment',
      data
    );
  }
  getRelatedDepartments(key: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/getRelatedDepartments',
      key
    );
  }
  addRelatedProcess(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/addRelatedProcess',
      data
    );
  }
  editRelatedProcess(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/editRelatedProcess',
      data
    );
  }
  deleteRelatedProcess(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/deleteRelatedProcess',
      data
    );
  }
  getRelatedProcesses(key: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/getRelatedProcess',
      key
    );
  }
  addRelatedStandard(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/addRelatedStandard',
      data
    );
  }
  editRelatedStandard(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/editRelatedStandard',
      data
    );
  }
  deleteRelatedStandard(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/deleteRelatedStandard',
      data
    );
  }
  getRelatedStandards(key: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/getRelatedStandards',
      key
    );
  }

  SubmitDocumentQuestion(key: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/SubmitDocumentQuestion',
      key
    );
  }

  GetDocumentQuestion(key: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/GetDocumentQuestion',
      key
    );
  }

  AddDocumentQualification(key: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/AddDocumentQualification',
      key
    );
  }

  GetDocument(key: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/GetDocument',
      key
    );
  }

  DeleteDocumentQuestion(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/DeleteDocumentQuestion',
      data
    );
  }

  GetDistributionUsersByRevNo(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/GetDistributionUsersByRevNo',
      data
    );
  }

  GetFileFromServer(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/GetFileFromServer',
      data
    );
  }

  CheckDataTypeUsageInDocument(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/CheckDataTypeUsageInDocument',
      data
    );
  }

  getUserDepartments(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'Common/GetUserDepartments',
      data
    );
  }

  addDocumentApprovalAuthority(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/AddDocumentApprovalAuthority',
      data
    );
  }

  getDocumentApprovalAuthority(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/GetDocumentApprovalAuthority',
      data
    );
  }

  RemoveDocumentApprovalLevel(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/RemoveDocumentApprovalLevel',
      data
    );
  }

  DmsInactiveChangeRequest(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'DocumentManagement/AddInactiveChangeRequest', data);
  }


  CheckUserApprovalPermission(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/CheckUserApprovalPermission',
      data
    );
  }

  ChangeDocumentStatus(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/ChangeDocumentStatus',
      data
    );
  }

  ChangeRevisionStatus(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/ChangeRevisionStatus',
      data
    );
  }

  rejectDocument(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/RejectDocument',
      data
    );
  }

  rejectRevision(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/RejectRevision',
      data
    );
  }

  draftDocument(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'documentManagement/DraftDocument',
      data
    );
  }

  getApprovalAllowedRoles(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/GetApprovalAllowedRoles',
      data
    );
  }

  activate_inactivateDocument(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/Activate_InactivateDocument',
      data
    );
  }

  GetUserRolesandEmpId(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'Common_Lean/GetUserRolesandEmpId',
      data
    );
  }

  GetDocumentParticipants(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/GetDocumentParticipants',
      data
    );
  }

  SendMailInactive(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/SendMailInactive',
      data
    );
  }

  GetRolesInPlant(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/GetRolesInPlant',
      data
    );
  }

  GetRoles(): Observable<any[]> {
    return this.http.get<any[]>(
      this.baseUrl + 'Role/GetRoles'
    );
  }

  AddApprovalAllowedRoles(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/AddApprovalAllowedRoles',
      data
    );
  }

  DeleteApprovalAllowedRoles(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/DeleteApprovalAllowedRoles',
      data
    );
  }

  AddAllowedApprovers(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/AddAllowedApprovers',
      data
    );
  }

  AddSuperAdmin(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/AddSuperAdmin',
      data
    );
  }

  GetAllowedApprovers(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/GetAllowedApprovers',
      data
    );
  }
  GetCheckListFormDocumentMapping_ByDocId(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/GetCheckListFormDocumentMapping_ByDocId',
      data
    );
  }

  GetApprovalAllowedRoles(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/GetApprovalAllowedRoles',
      data
    );
  }


  GetSuperAdmin(): Observable<any> {
    return this.http.get<any[]>(
      this.baseUrl + 'documentManagement/GetSuperAdmin'
    );
  }

  DeleteSuperAdmin(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/DeleteSuperAdmin',
      data
    );
  }

  DeleteAllowedApprovers(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/DeleteAllowedApprovers',
      data
    );
  }

  DeleteAllowedApproversPlantWise(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/DeleteAllowedApproversPlantWise',
      data
    );
  }

  GetDistributors(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/GetDistributors',
      data
    );
  }

  AddDistributor(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/AddDistributor',
      data
    );
  }

  DeleteDistributor(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/DeleteDistributor',
      data
    );
  }

  getRevisionByrevId(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/GetRevisionDataByRevId',
      data
    );
  }

  DeleteCRByReviewId(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/DeleteCRByReviewId',
      data
    );
  }

  UpdateCRByReviewId(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/UpdateCRByReviewId',
      data
    );
  }

  GetDocumentQuestionsByRevisionNo(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/GetDocumentQuestionsByRevisionNo',
      data
    );
  }

  GetUserIdByEmpInfoId(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/GetUserIdByEmpInfoId',
      data
    );
  }

  SendMail(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/SendMail',
      data
    );
  }

  addSupportiveDocument(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/AddSupportiveDocument',
      data
    );
  }

  getSupportiveDocument(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/GetSupportiveDocument',
      data
    );
  }

  deleteSupportiveDocument(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'documentManagement/DeleteSupportiveFile',
      data
    );
  }


  saveGridConfiguration(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'Grid/SaveGridConfiguration',
      data
    );
  }

  getGridConfiguration(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'Grid/GetGridConfiguration',
      data
    );
  }


  getDistributionGroupMapping(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "MyDepartment/getDistributionGroupMapping", data);
  }

  addDistributioinGroupMapping(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "MyDepartment/addDistributionGroupMapping", data);
  }

  editDistributionGroupMapping(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "MyDepartment/editDistributionGroupMapping", data);
  }

  deleteDistributionGroupMapping(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "MyDepartment/deleteDistributionGroupMapping", data);
  }

  getEmpIdByRole(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "DocumentManagement/GetEmpInfoIdByRoleIds", data);
  }
  GetDocumentCRApprovalStatus(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "DocumentManagement/GetDocumentCRApprovalStatus", data);
  }
  AddDMSInactiveRemarks(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "DocumentManagement/addDMSInactiveRemarks", data)
  }
  EditObseleteDocumentFile(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "DocumentManagement/EditObseleteDocumentFile", data)
  }
  GetDMSLogs(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "DocumentManagement/GetDMSLogs", data);
  }
  saveReviewReminderSetting(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "DocumentManagement/SaveReviewReminderSetting", data);
  }
  getReviewReminderSetting(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "DocumentManagement/GetReviewReminderSetting", data);
  }

  deleteReviewReminder(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "DocumentManagement/deleteReviewReminder", data);
  }
  getChecklistHistory(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'DocumentManagement/checklisthistory',
      data
    );
  }
  getAssigneeUser(docId: number): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + "DocumentManagement/getDocUserPermissions",
      docId  
    );
  }

  saveDocumentAssignment(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "DocumentManagement/InsertUserCodesAsync", data);
  }
}

